export default "__VITE_ASSET__8de0a3fc__"